import React from 'react';
import styled from 'styled-components';
import { SCAFFOLDING, MAPTOOLBAR } from 'theme';

const StyledMapWrapperScroll = styled.div`
    position: absolute;
    top: ${MAPTOOLBAR.HEIGHT};
    right: 0;
    bottom: 0;
    left: ${SCAFFOLDING.GUTTER};
    overflow: scroll; /* Force a scrollbar because percentage dimensions get affected by the scrollbar */
    -webkit-overflow-scrolling: touch;
`;

// eslint-disable-next-line react/prefer-stateless-function
export default class MapWrapperScroll extends React.Component {
    render() {
        const { children, ...props } = this.props;

        return <StyledMapWrapperScroll {...props}>{children}</StyledMapWrapperScroll>;
    }
}
